import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import Header from "../components/Header";

export default function Contact() {
  return (
    <div className="bb container">
      <Header />
      <h3 className="text-white mt-5">Contact Us</h3>
      <div className="text-white">
        <a href="mailto:codeindica@gmail.com" className="d-flex mt-5">
          <h1 className="fw-bolder">codeindica@gmail.com</h1>
          <FiArrowUpRight />
        </a>
      </div>
    </div>
  );
}
